import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { IResponse, ISuccess } from '@interfaces/index';
import { CookieService } from 'ngx-cookie-service';
import { PaymentService } from 'projects/assessments/src/app/services/payment.service';
import { catchError, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-b2c-payment',
  templateUrl: './b2c-payment.component.html',
  styleUrl: './b2c-payment.component.scss'
})
export class B2cPaymentComponent {

  payment: ISuccess | null = null;
  session_id: string | null = null;
  loading = false;

  constructor(
    protected _payment_service: PaymentService,
    protected _route: ActivatedRoute,
    protected _router: Router,
    private _cookieService: CookieService  // Inject CookieService
  ) { }

  ngOnInit() {
    this.loading = true;
    this._route.queryParams.pipe(
      switchMap(
        (params: Params) => {
          this.session_id = params['session_id'];
          return this._payment_service.success(this.session_id as string);
        }
      ),
      catchError((err) => {
        this._router.navigate(['/'])
        return of({code: 400, data: err});
      })
    ).subscribe(
      (response: IResponse<ISuccess>) => {
        this.payment = response.data
        this.loading = false;

        // Clear cookies after successful payment
        if (this.payment) {
          this.clearCookies();
        }
      },
    );
  }

  // Method to clear all cookies
  private clearCookies(): void {
    this._cookieService.deleteAll('/', environment.domain);
  }
}
